import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { TeemappService } from '@teem/services/teemapp.service';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';
import { country as CountryApi } from '@teem/constants/api';
import { CountryService } from '@teem/services/country.service';
import { TapContractModalComponent } from '@teem/setting-module/modals/tap-contract-modal/tap-contract-modal.component';
import { TeemContractModalComponent } from '@teem/app/features/setting/modals/teem-contract-modal/teem-contract-modal.component';
import { HyperpaySubscriptionModalComponent } from '@teem/setting-module/modals/hyperpay-subscription-modal/hyperpay-subscription-modal.component';
import { HIDE_PAYMENT_DATE } from '@teem/constants/defaults';
import * as RegexPattern from '@teem/constants/regex-patterns';
import { environment } from '@teem/environments/environment';
import { NewtapContractModelComponent } from '@teem/setting-module/modals/newtap-contract-model/newtap-contract-model.component';

declare var $;

@Component({
  selector: 'tap-tab',
  templateUrl: './tap-tab.component.html',
  styleUrls: ['./tap-tab.component.scss']
})
export class TapTabComponent implements OnInit {

  @Output() public updateUserDetails = new EventEmitter();
  @Output() public goToPlan = new EventEmitter();

  submitted: boolean = false;
  userDetails: any = null;
  bankListApi: string = CountryApi.saudi_banks;
  banks: any = [];
  formSubmit: boolean = false;
  tapPaymentForm: any = {};
  fileSignDoc: File = null;
  fileNationalDoc: File = null;
  fileIdentificationDoc: File = null;
  businessLogoFile: File = null;
  ibanCertificateFile: File = null;
  
  approvedSignatureFile: File = null;
  proofOfAddresseFile: File = null;
  vatCertificateFile: File = null;
  trademarkProofOwnershipFile: File = null;
  idFrontBackFile: File = null;

  // countries: any = [{ 'id': 682, 'name': 'Saudi Arabia' }, { 'id': 784, 'name': 'United Arab Emirates' }, { 'id': 48, 'name': 'Bahrain' }, { 'id': 414, 'name': 'Kuwait' }];
  countries: any = [{ 'id': 682, 'name': 'Saudi Arabia' }, { 'id': 784, 'name': 'United Arab Emirates' }, { 'id': 414, 'name': 'Kuwait' }];
  selectedCountry: any = { 'id': 682, 'name': 'Saudi Arabia' };
  selectedDocumentType: any;
  selectedIdentificationType: any;
  selectedMerchantConsidered: any;
  merchantConsidered: any = [{ 'id': 'yes', 'name': 'Yes' }, { 'id': 'no', 'name': 'No' }];
  documentType: any = [{ 'id': 'commercial_registration', 'name': 'Commercial Registration' }, { 'id': 'freelancer_id', 'name': 'Freelancer Id' }];
  identificationType: any = [{ 'id': 'national_id', 'name': 'National ID' }, { 'id': 'iqama', 'name': 'Iqama' }];
  selectedBank: any;
  hasFreelanceIdError = false;
  freelanceErrorMessage = null;
  labelStatus: string = 'default_show';
  dueDate: any = moment(HIDE_PAYMENT_DATE);
  nowDate: any = moment();
  tapPaymentFormGroup: FormGroup;
  tapBankFormGroup: FormGroup;
  tap_edit_info: boolean = false;
  contractSign: boolean = false;

  @Input("userDetails")
  set getInfo(val: any) {
    this.userDetails = val;
    this.tapPaymentForm = Object.assign({}, val);
    console.log(this.userDetails)
    // this.tapPaymentForm.tap_info.bank_name = 1;
    this.tapPaymentForm.tap_info.country =  this.userDetails?.tap_info?.country ?  this.userDetails.tap_info.country : null;
    this.selectedCountry = { 'id': this.userDetails?.tap_info?.country, 'name': this.userDetails?.tap_info?.get_country?.name };
    this.tapPaymentForm.tap_info.business_logo = null;
    this.tapPaymentForm.tap_info.commercial_document = null;
    this.tapPaymentForm.tap_info.identification_document = null;
    this.tapPaymentForm.tap_info.iban_certificate = null;

    this.tapPaymentForm.tap_info.approved_signature = null;
    // this.tapPaymentForm.tap_info.passport_work_permit = null;
    this.tapPaymentForm.tap_info.id_front_back = null;
    this.tapPaymentForm.tap_info.proof_of_address = null;
    this.tapPaymentForm.tap_info.vat_certificate = null;
    this.tapPaymentForm.tap_info.trademark_proof_of_ownership = null;
    
    // this.onChangeCountry(this.userDetails?.tap_info?.country);

    this.tapPaymentForm.tap_info.document_type = this.userDetails?.tap_info ? this.userDetails.tap_info.document_type : 'commercial_registration';
    this.tapPaymentForm.tap_info.identification_type = this.userDetails?.tap_info ? this.userDetails.tap_info.identification_type : 'national_id';
    this.tapPaymentForm.tap_info.merchant_considered = this.userDetails?.tap_info ? this.userDetails.tap_info.merchant_considered : 'yes';
    this.selectedBank = { 'id': this.tapPaymentForm?.tap_info.bank?.id, 'bank_name': this.tapPaymentForm?.tap_info.bank?.bank_name_en };
    
    this.selectedCountry = this.getCountryByFind(this.userDetails?.tap_info?.country);
    
    if (this.selectedCountry?.name != 'Saudi Arabia') {
      this.documentType = [{ 'id': 'commercial_registration', 'name': 'Commercial Registration' }];      
      this.identificationType = [{ 'id': 'national_id', 'name': 'National ID' }, { 'id': 'passport', 'name': 'Passport copy and Address' }, { 'id': 'work_permit', 'name': 'Work Permit' }];
    } else {
      this.documentType = [{ 'id': 'commercial_registration', 'name': 'Commercial Registration' }, { 'id': 'freelancer_id', 'name': 'Freelancer Id' }];
      this.identificationType = [{ 'id': 'national_id', 'name': 'National ID' }, { 'id': 'iqama', 'name': 'Iqama' }];
    }

    if (this.tapPaymentForm?.tap_info.document_type == 'commercial_registration') {
      this.selectedDocumentType = { 'id': 'commercial_registration', 'name': 'Commercial Registration' };
    } if (this.tapPaymentForm?.tap_info.document_type == 'freelancer_id') {
      this.selectedDocumentType = { 'id': 'freelancer_id', 'name': 'Freelancer Id' };
    }

    if (this.tapPaymentForm?.tap_info.identification_type == 'national_id') {
      this.selectedIdentificationType = { 'id': 'national_id', 'name': 'National ID' };
    } if (this.tapPaymentForm?.tap_info.identification_type == 'iqama') {
      this.selectedIdentificationType = { 'id': 'iqama', 'name': 'Iqama' };
    } if (this.tapPaymentForm?.tap_info.identification_type == 'passport') {
      this.selectedIdentificationType = { 'id': 'passport', 'name': 'Passport copy and Address' };
    } if (this.tapPaymentForm?.tap_info.identification_type == 'work_permit') {
      this.selectedIdentificationType = { 'id': 'work_permit', 'name': 'Work Permit' };
    }

    if (this.tapPaymentForm?.tap_info.merchant_considered == 'yes') {
      this.selectedMerchantConsidered = { 'id': 'yes', 'name': 'Yes' };
    } if (this.tapPaymentForm?.tap_info.merchant_considered == 'no') {
      this.selectedMerchantConsidered = { 'id': 'no', 'name': 'No' };
    }

    if (this.userDetails?.subscription.subscription_status == 'free') {
      this.labelStatus = 'free_user';
    } else {
      this.labelStatus = 'paid_user';
    }
  }

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private teemappService: TeemappService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private countryService: CountryService,
    private cdr: ChangeDetectorRef, 
    private fb: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.inittapPaymentForm();
    this.fetchBanks();
    
  }

  inittapPaymentForm() {
    this.tapPaymentFormGroup = this.fb.group({
      business_name_en: [this.tapPaymentForm?.tap_info.business_name_en, [Validators.required]],
      business_name_ar: [this.tapPaymentForm?.tap_info.business_name_ar],
      // business_type: [this.tapPaymentForm?.tap_info.type, Validators.required],
      legal_name: [this.tapPaymentForm?.tap_info.legal_name, [Validators.required]],
      legal_name_ar: [this.tapPaymentForm?.tap_info.legal_name_ar],
      bank_account_number: [this.tapPaymentForm?.tap_info.bank_account_number, Validators.required],
      bank_account_name: [this.tapPaymentForm?.tap_info.bank_account_name, [Validators.required, Validators.pattern(RegexPattern.english_string)]],
      bank_address: [this.tapPaymentForm?.tap_info.bank_address, [Validators.required]],
      bank_name: [this.tapPaymentForm?.tap_info.bank_name, Validators.required],
      country: [this.tapPaymentForm?.tap_info.country, Validators.required],
      iban_number: [this.tapPaymentForm?.tap_info.iban_number, [Validators.required, Validators.pattern(RegexPattern.english_string)]],
      swift_code: [this.tapPaymentForm?.tap_info.swift_code, Validators.required],
      document_type: [this.tapPaymentForm?.tap_info.document_type, Validators.required],
      document_number: [this.tapPaymentForm?.tap_info.document_number, Validators.required],
      document_expiry_date: [this.tapPaymentForm?.tap_info.document_expiry_date, Validators.required],
      identification_number: [this.tapPaymentForm?.tap_info.identification_number, Validators.required],
      identification_type: [this.tapPaymentForm?.tap_info.identification_type, Validators.required],
      identification_expiry_date: [this.tapPaymentForm?.tap_info.identification_expiry_date, Validators.required],
      instagram: [this.tapPaymentForm?.tap_info.instagram, [Validators.required, Validators.pattern(RegexPattern.url)]],
      maroof: [this.tapPaymentForm?.tap_info.maroof, [Validators.pattern(RegexPattern.url)]],
      website: [this.tapPaymentForm?.tap_info.website, [Validators.pattern(RegexPattern.url)]],
      expected_sales: [this.tapPaymentForm?.tap_info.expected_sales, Validators.required],
      expected_clients: [this.tapPaymentForm?.tap_info.expected_clients, Validators.required],
      merchant_considered: [this.tapPaymentForm?.tap_info.merchant_considered],
      residential_address: [this.tapPaymentForm?.tap_info.residential_address, Validators.required],
      work_address: [this.tapPaymentForm?.tap_info.work_address, Validators.required],

      iban_certificate: [this.tapPaymentForm?.tap_info.iban_certificate,],
      business_logo: [this.tapPaymentForm?.tap_info.business_logo,],
      commercial_document: [this.tapPaymentForm?.tap_info.commercial_document,],
      identification_document: [this.tapPaymentForm?.tap_info.identification_document,],

      approved_signature: [this.tapPaymentForm?.tap_info.approved_signature,],
      // passport_work_permit: [this.tapPaymentForm?.tap_info.passport_work_permit,],
      id_front_back: [this.tapPaymentForm?.tap_info.id_front_back,],
      proof_of_address: [this.tapPaymentForm?.tap_info.proof_of_address,],
      vat_certificate: [this.tapPaymentForm?.tap_info.vat_certificate,],
      trademark_proof_of_ownership: [this.tapPaymentForm?.tap_info.trademark_proof_of_ownership,],
      trade_name: [this.tapPaymentForm?.tap_info.trade_name, [Validators.required]],
      store_name: [this.tapPaymentForm?.tap_info.store_name ?? this.userDetails?.business_name, [Validators.required]],
    });

    this.tapPaymentFormGroup.get('website').valueChanges.subscribe(value => {
      if (value) {
        this.tapPaymentFormGroup.get('instagram').clearValidators();
        this.tapPaymentFormGroup.controls.instagram.setValidators([Validators.pattern(RegexPattern.url)]);
      }else{
        this.tapPaymentFormGroup.controls.instagram.setValidators([Validators.required, Validators.pattern(RegexPattern.url)]);
      }
      this.tapPaymentFormGroup.get('instagram').updateValueAndValidity();
    });

    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 2000);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 300);
  }

  async fetchBanks() {
    let countryId = this.selectedCountry?.id;
    await this.countryService.banksByCountry(countryId).subscribe((data: any) => {
      this.banks = data;
      this.banks.forEach((element, index) => {
        if (element.id == this.tapPaymentForm?.tap_info.bank?.id) {
          this.selectedBank = { 'id': this.tapPaymentForm?.tap_info.bank?.id, 'bank_name': element.bank_name };
        } else {
          if(index == 0) {
            this.selectedBank = { 'id': element.id, 'bank_name': element.bank_name };
            this.tapPaymentFormGroup.get("bank_name").setValue(element.id);
          }
        }
      });

      setTimeout(() => {
        $('select[nice-select]').niceSelect('update');
      }, 2000);
      
      this.cdr.detectChanges();
    });
  }

  onBankSelected(bank: any) {
    this.selectedBank = {
      'id': bank?.id,
      'name': bank?.text
    }
  }

  // On file Select
  onChangeDoc(event) {
    this.fileSignDoc = event.target.files[0];
    let filename = this.fileSignDoc.name;
    $('#file-upload').prev('label').text(filename);
  }

  onChangeBusinessLogo(event) {
    this.businessLogoFile = event.target.files[0];
    let filename = this.businessLogoFile.name;
    $('#business-logo-upload').prev('label').text(filename);
  }

  onChangeIbanCertificate(event) {
    this.ibanCertificateFile = event.target.files[0];
    let filename = this.ibanCertificateFile.name;
    $('#iban-certificate-upload').prev('label').text(filename);
  }

  onChangeIdentificationDoc(event) {
    this.fileIdentificationDoc = event.target.files[0];
    let filename = this.fileIdentificationDoc.name;
    $('#identification-file-upload').prev('label').text(filename);
  }

  onChangeFileInput(event) {
    console.log(event)
    let id = event.target.id;
    let filename = event.target.files[0].name;
    if (id == 'approved-signature') {
      this.approvedSignatureFile = event.target.files[0];
    }
    if (id == 'proof-of-address') {
      this.proofOfAddresseFile = event.target.files[0];
    }
    if (id == 'vat-certificate') {
      this.vatCertificateFile = event.target.files[0];
    }
    if (id == 'trademark-proof-ownership') {
      this.trademarkProofOwnershipFile = event.target.files[0];
    }
    if (id == 'id-front-back') {
      this.idFrontBackFile = event.target.files[0];
    }
    $('#'+id).prev('label').text(filename);
  }

  validateFile(){
    if (this.tapPaymentForm?.tap_info.commercial_document  == null && this.tapPaymentForm?.tap_info.document_file_name == null) {
      this.tapPaymentFormGroup.controls.commercial_document.setValidators(Validators.required);
      this.tapPaymentFormGroup.controls.commercial_document.updateValueAndValidity();
    }
    if (this.tapPaymentForm?.tap_info.identification_document  == null && this.tapPaymentForm?.tap_info.identification_file_name == null) {
      this.tapPaymentFormGroup.controls.identification_document.setValidators(Validators.required);
      this.tapPaymentFormGroup.controls.identification_document.updateValueAndValidity();
    }
    if (this.tapPaymentForm?.tap_info.iban_certificate  == null && this.tapPaymentForm?.tap_info.iban_certificate_file_name == null) {
      this.tapPaymentFormGroup.controls.iban_certificate.setValidators(Validators.required);
      this.tapPaymentFormGroup.controls.iban_certificate.updateValueAndValidity();
    }
  }
   
  businessInfoUpdateNotify() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.tap.you_want_update_tap_business_info,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.cancel
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        let fd = this.userDetails.uuid;
        this.userService.businessInfoUpdateNotify(fd).subscribe(
          (res: any) => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.done, i18n.tap.admin_get_touch_with_you_soon, 'success');
          },
          (err) => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          })
      }
        
    });
    
  }

  updateStatus(uuid, event: any) {
    console.log(event);
    let checked = event.target.checked;
    this.userDetails.tap_info.is_enable = !checked;
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.you_want_to_update_status,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        let fd: any = {};
        fd.uuid = uuid;
        fd.type = 'tap';
        this.loaderService.startLoading();
        this.userService.updateStatus(fd).subscribe((data: any) => {
          this.loaderService.stopLoading();
          event.target.checked = checked;
          this.userDetails.tap_info.is_enable = !checked;
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.status_updated_successfully, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          event.target.checked = !checked;
          this.userDetails.tap_info.is_enable = checked;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }else{
        event.target.checked = !checked;
        this.userDetails.tap_info.is_enable = checked;
        return false;
      }
    });
  }
  
  onSubmit() {
    this.validateFile();
    this.formSubmit = true;
    if (this.tapPaymentFormGroup.valid && !this.hasFreelanceIdError) {
      this.loaderService.startLoading();

      let fd = this.tapPaymentFormGroup.value;
      if (this.fileSignDoc) fd.commercial_document = this.fileSignDoc;
      if (this.fileIdentificationDoc) fd.identification_document = this.fileIdentificationDoc;
      if (this.businessLogoFile) fd.business_logo = this.businessLogoFile;
      if (this.ibanCertificateFile) fd.iban_certificate = this.ibanCertificateFile;
      if (this.approvedSignatureFile) fd.approved_signature = this.approvedSignatureFile;
      if (this.proofOfAddresseFile) fd.proof_of_address = this.proofOfAddresseFile;
      if (this.vatCertificateFile) fd.vat_certificate = this.vatCertificateFile;
      if (this.trademarkProofOwnershipFile) fd.trademark_proof_of_ownership = this.trademarkProofOwnershipFile;
      if (this.idFrontBackFile) fd.id_front_back = this.idFrontBackFile;

      this.userService.addTapInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();

          this.tapPaymentForm = Object.assign({}, res.user);
          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            Object.assign(userInfo, res.user);
            Object.assign(this.userDetails, res.user);
            this.sharedDataService.setItem('userInfo', userInfo);
            
            this.selectedBank = { 'id': this.tapPaymentForm?.tap_info.bank?.id, 'bank_name': this.tapPaymentForm?.tap_info.bank?.bank_name_en };
            
            if (this.tapPaymentForm?.tap_info.document_type == 'commercial_registration') {
              this.selectedDocumentType = { 'id': 'commercial_registration', 'name': 'Commercial Registration' };
            } if (this.tapPaymentForm?.tap_info.document_type == 'freelancer_id') {
              this.selectedDocumentType = { 'id': 'freelancer_id', 'name': 'Freelancer Id' };
            }
            
            if (this.tapPaymentForm?.tap_info.identification_type == 'national_id') {
              this.selectedIdentificationType = { 'id': 'national_id', 'name': 'National ID' };
            } if (this.tapPaymentForm?.tap_info.identification_type == 'iqama') {
              this.selectedIdentificationType = { 'id': 'iqama', 'name': 'Iqama' };
            }
        
            if (this.tapPaymentForm?.tap_info.merchant_considered == 'yes') {
              this.selectedMerchantConsidered = { 'id': 'yes', 'name': 'Yes' };
            } if (this.tapPaymentForm?.tap_info.merchant_considered == 'no') {
              this.selectedMerchantConsidered = { 'id': 'no', 'name': 'No' };
            }
          }
          Swal.fire(
            i18n.hyperpay.your_request_has_been_sent,
            i18n.hyperpay.thank_you_for_entering_your_application,
            'success'
          );
        },
        (err) => {
          this.loaderService.stopLoading();
          this.userDetails.is_tap_info = false;
          this.contractSign = false;
          if (err.status === 403) {
            console.log(err.error.errors);
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              let serverError = [];
              Object.keys(validationErrors).forEach((prop) => {
                if (validationErrors[prop]['message']) {
                  serverError.push(validationErrors[prop]['message']);
                } else if (validationErrors[prop]['description']) {
                  serverError.push(validationErrors[prop]['description']);
                }
              })
              Swal.fire(i18n.alert.error, JSON.stringify(serverError), 'error');
            }
          } else if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.tapPaymentFormGroup.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          } else {
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          }
        }
      );
    }
  }

  editForm() {
    // this.tap_edit_info = true;
    // this.tapBankFormGroup = this.fb.group({
    //   legal_name: [this.tapPaymentForm?.tap_info.legal_name, [Validators.required]],
    //   legal_name_ar: [this.tapPaymentForm?.tap_info.legal_name_ar],
    //   bank_account_number: [this.tapPaymentForm?.tap_info.bank_account_number, Validators.required],
    //   bank_account_name: [this.tapPaymentForm?.tap_info.bank_account_name, Validators.required],
    //   iban_number: [this.tapPaymentForm?.tap_info.iban_number, Validators.required],
    //   swift_code: [this.tapPaymentForm?.tap_info.swift_code, Validators.required],
    // });
    this.userDetails.is_tap_info = false;
    this.selectedBank = { 'id': this.tapPaymentForm?.tap_info.bank?.id, 'bank_name': this.tapPaymentForm?.tap_info.bank?.bank_name_en };
    if (this.tapPaymentForm?.tap_info.document_type == 'commercial_registration') {
      this.selectedDocumentType = { 'id': 'commercial_registration', 'name': 'Commercial Registration' };
    } if (this.tapPaymentForm?.tap_info.document_type == 'freelancer_id') {
      this.selectedDocumentType = { 'id': 'freelancer_id', 'name': 'Freelancer Id' };
    }
  }

  onTapBankSubmit() {
    this.formSubmit = true;
    if (this.tapBankFormGroup.valid) {
      this.loaderService.startLoading();
      let fd = this.tapBankFormGroup.value;
      this.userService.updateTapInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();

          this.tapPaymentForm = Object.assign({}, res.user);
          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            Object.assign(userInfo, res.user);
            Object.assign(this.userDetails, res.user);
            this.sharedDataService.setItem('userInfo', userInfo);
          }
          Swal.fire(
            i18n.hyperpay.your_request_has_been_sent,
            i18n.hyperpay.thank_you_for_entering_your_application,
            'success'
          );
        },
        (err) => {
          this.loaderService.stopLoading();
          
          if (err.status === 403) {
            console.log(err.error.errors);
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              let serverError = [];
              Object.keys(validationErrors).forEach((prop) => {
                serverError.push(validationErrors[prop]['message']);
              })
              Swal.fire(i18n.alert.error, JSON.stringify(serverError), 'error');
            }
          } else if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.tapBankFormGroup.controls[prop]?.setErrors({
                  serverError: validationErrors[prop]
                });
              })
            }
          } else {
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          }
        }
      );
    }
  }

  onChangeDocType() {
    this.tapPaymentFormGroup.get("document_number").setValue(null);
    this.tapPaymentFormGroup.get("document_expiry_date").setValue(null);
    this.hasFreelanceIdError = false;
    this.cdr.detectChanges();
  }

  validateCrFreelance(searchValue: string): void {
    if (searchValue) {
      let fd = {
        freelance_id: searchValue,
        document_type: this.tapPaymentFormGroup.value.document_type
      };
      this.loaderService.startLoading();

      this.teemappService.verifyCrFreelance(fd).subscribe((data: any) => {
        this.loaderService.stopLoading();

        if (data.status == 'success') {
          this.tapPaymentFormGroup.get("document_expiry_date").setValue(data.expiry_date);
          this.hasFreelanceIdError = false;
        } else {
          this.hasFreelanceIdError = true;
          this.freelanceErrorMessage = data.message;
        }
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });

    }
  }

  onChangeCountry(id) {
    this.selectedCountry = this.getCountryByFind(id);
    
    this.selectedDocumentType = null; // { 'id': 'commercial_registration', 'name': 'Commercial Registration' };
    this.selectedIdentificationType = null; // { 'id': 'national_id', 'name': 'National ID' };
    this.tapPaymentForm.tap_info.document_type = null; // 'commercial_registration';
    this.tapPaymentForm.tap_info.identification_type = null; // 'national_id';

    this.tapPaymentFormGroup.get("document_type").setValue(null);
    this.tapPaymentFormGroup.get("identification_type").setValue(null);

    if (this.selectedCountry?.name != 'Saudi Arabia') {
      this.documentType = [{ 'id': 'commercial_registration', 'name': 'Commercial Registration' }];      
      this.identificationType = [{ 'id': 'national_id', 'name': 'National ID' }, { 'id': 'passport', 'name': 'Passport copy and Address' }, { 'id': 'work_permit', 'name': 'Work Permit' }];
    } else {
      this.documentType = [{ 'id': 'commercial_registration', 'name': 'Commercial Registration' }, { 'id': 'freelancer_id', 'name': 'Freelancer Id' }];
      this.identificationType = [{ 'id': 'national_id', 'name': 'National ID' }, { 'id': 'iqama', 'name': 'Iqama' }];
    }

    if (this.selectedCountry?.name == 'United Arab Emirates') {
      ['id_front_back', 'proof_of_address', 'vat_certificate', 'trademark_proof_of_ownership'].forEach((field: string) => {
        this.tapPaymentFormGroup.get(field).setValidators([Validators.required]);
        this.tapPaymentFormGroup.get(field).updateValueAndValidity();
      });
    }else if (this.selectedCountry?.name == 'Kuwait') {
      ['id_front_back'].forEach((field: string) => {
        this.tapPaymentFormGroup.get(field).setValidators([Validators.required]);
        this.tapPaymentFormGroup.get(field).updateValueAndValidity();
      });
    }else{
      ['id_front_back', 'proof_of_address', 'vat_certificate', 'trademark_proof_of_ownership'].forEach((field: string) => {
        this.tapPaymentFormGroup.get(field).setValue(null);
        this.tapPaymentFormGroup.get(field).clearValidators();      
        this.tapPaymentFormGroup.get(field).updateValueAndValidity();
      });
      this.proofOfAddresseFile = this.vatCertificateFile = this.trademarkProofOwnershipFile = this.idFrontBackFile = null;
    }

    if (this.selectedCountry?.name == 'Egypt' || this.selectedCountry?.name == 'Kuwait') {
      ['approved_signature'].forEach((field: string) => {
        this.tapPaymentFormGroup.get(field).setValidators([Validators.required]);
        this.tapPaymentFormGroup.get(field).updateValueAndValidity();
      });
    }else{
      ['approved_signature'].forEach((field: string) => {
        this.tapPaymentFormGroup.get(field).setValue(null);
        this.tapPaymentFormGroup.get(field).clearValidators();      
        this.tapPaymentFormGroup.get(field).updateValueAndValidity();
      });
      this.approvedSignatureFile = null;
    }
    
    this.fetchBanks();

    this.cdr.detectChanges();

    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 2000);
  }

  getCountryByFind(id){
    return this.countries.find(x => x.id == id);
  }

  downloadMyFile(url: string, filename: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onSignContract() {
    console.log(this.tapPaymentFormGroup.valid)
    console.log(this.tapPaymentFormGroup)
    this.validateFile();
    this.formSubmit = true;
    if (this.tapPaymentFormGroup.valid && !this.hasFreelanceIdError) {
      let tapPaymentFromData = this.tapPaymentFormGroup.value;

      // 
      tapPaymentFromData.bank_holder_name = tapPaymentFromData.bank_account_name;
      tapPaymentFromData.iban = tapPaymentFromData.iban_number;
      tapPaymentFromData.cr_number = tapPaymentFromData.document_number;
      tapPaymentFromData.address = tapPaymentFromData.work_address;
      tapPaymentFromData.invoice_email = this.userDetails?.business_email;
      tapPaymentFromData.identification_number = tapPaymentFromData.identification_number;
      tapPaymentFromData.manager_name = this.userDetails?.full_name;
      tapPaymentFromData.bank_name = this.selectedBank?.name;

      // const modalRef = this.modalService.open(TapContractModalComponent);
      const modalRef = this.modalService.open(TeemContractModalComponent);
      // const modalRef = this.modalService.open(NewtapContractModelComponent);      
      modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "fatoorahcontract";
      modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.classList.add('fatoorah-contract1');
      // Set id on modal dialog
      modalRef.componentInstance.userDetails = this.userDetails;
      modalRef.componentInstance.contractFromData = tapPaymentFromData;
      modalRef.componentInstance.paymentGateWay = 'tap';
      modalRef.componentInstance.bankName = this.selectedBank?.name;

      modalRef.result.then(result => {
        this.contractSign = true;
        this.userDetails.is_tap_info = false;
        this.onSubmit();
      }, fallbackResult => {
        // do nothing
        this.contractSign = false;
      })
    }
  }

  goBack() {
    this.userDetails.is_tap_info = true;
    this.tap_edit_info = false;
  }

  downloadPdf() {
    if ((window as any).LOCALE == 'ar') {
      (window as any).open(`${environment.baseUrl}/images/pdf/pdf-tap-online-payments-arabic.pdf`, '_blank', 'location=yes');
    } else {
      (window as any).open(`${environment.baseUrl}/images/pdf/pdf-tap-online-payments-english.pdf`, '_blank', 'location=yes');
    }
  }
  
}
